import React, {useState} from "react";
import {Button, FormControl, Form, Modal, Spinner} from "react-bootstrap";
import ApiService from "../../ApiService";
import './style.css';

const M19Input = (props) => {
    const [loading, setLoadingStatus] = useState(false);
    const [showError, setErrorStatus] = useState(false);
    const [newTubeId, setTubeId] = useState(props.tubeId);
    const addTubeIdToKit = async () => {
        setLoadingStatus(true);
        setErrorStatus(false);
        try{
            await ApiService.registerCovidKit({serialNumber: newTubeId, kitId: props.kitId});
            props.handleClose(true);
        } catch(e){
            setErrorStatus(true);
        } finally{
            setLoadingStatus(false);
        }
    }
    return (
        <Modal className="m19-input-modal"
                onHide={props.handleClose}
                keyboard={false}
                onClick={e => e.stopPropagation()}
                animation={false}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={props.show}
            >
                <Modal.Header id="modalHeader">
                    <Modal.Title>Enter the test tube serial number</Modal.Title>
                </Modal.Header>
                <Modal.Body id="modalBody">
                    {
                        loading && 
                        <div>
                            <Spinner animation="border" role="status">
                                    <span className="sr-only">Loading...</span>
                                </Spinner>
                        </div>
                    }
                    <div>
                        {
                            showError && 
                            <p>Error encountered while adding the test tube serial number</p>
                        }
                        <Form.Group className="mb-3">
                            <Form.Control
                            placeholder="Tube Serial Number"
                            aria-label="Tube serial number"
                            aria-describedby="tube-serial"
                            value={newTubeId}
                            onChange = {(e) => setTubeId(e.target.value)}
                            disabled={loading}
                            id="borderless"
                            />
                        </Form.Group>
                    </div>  
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" disabled={loading} onClick={(e) => props.handleClose(false)}>Close</Button>
                    <Button id="msg_reply" class="replyButton sendButton text-right" onClick={addTubeIdToKit} disabled={showError || loading || props.disabled}>Submit <i class="fa fa-paper-plane"aria-hidden="true"></i></Button>
                </Modal.Footer>
        </Modal>
    )
}
export default M19Input;
